export class TimeSheetSetting {
  useProject: boolean
  calcTime: boolean
  useDate: number = 0
  calcTimeOnCopy: boolean
  useDateOnCopy: number = 0
  singleUser: boolean
  closeAfterNew: boolean
}
